import styled, { css } from 'styled-components';

interface LabelProps {
  $tone?: 'inverted';
  $faded?: boolean;
}

export const Label = styled.div.withConfig({ componentId: 'sc-11lhh33-0' })<LabelProps>`
    font-size: var(--font-size-xxsmall-static);
    font-weight: var(--font-weight-bold);
    color: var(--c-text-muted);
    letter-spacing: 0.15em;
    text-transform: uppercase;

    ${({ $tone }) =>
      $tone === 'inverted'
        ? css`
                  color: var(--c-text-media);
              `
        : undefined}

    ${({ $faded }) =>
      $faded &&
      css`
            opacity: 0.7;
        `}
`;
